module.exports = __webpack_public_path__ + "img/horizontal_3_2_pp2_8019.4972d35d.png";